import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=622e5cfc&"
import script from "./Employee.vue?vue&type=script&lang=ts&"
export * from "./Employee.vue?vue&type=script&lang=ts&"
import style0 from "./Employee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports